module.exports = "pegasus/assets/tech/medium/4.jpg";